import React, { useState } from "react";
import { Link } from "react-router-dom";

type PopupType = "biografi" | "lhkpn" | "kinerja" | "vote" | null;

interface EntryDataProps {
  id: number;
}

const EntryData: React.FC<EntryDataProps> = ({ id }) => {
  return (
    <div className="mt-12">
      <h1 className="text-xl font-bold mb-4">Entry Data</h1>
      <div className="flex flex-wrap gap-3">
        <Link to={`/dashboard/biografi/${id}`}>
          <div className="bg-primary text-white px-4 py-2 rounded">Biografi</div>
        </Link>
        <Link to={`/dashboard/lhkpn/${id}`}>
          <div className="bg-primary text-white px-4 py-2 rounded">LHKPN</div>
        </Link>
        <Link to={`/dashboard/kinerja/${id}`}>
          <div className="bg-primary text-white px-4 py-2 rounded">Kinerja</div>
        </Link>

        <Link to="/dashboard/aspirasi">
          <div className="bg-primary text-white px-4 py-2 rounded">Aspirasi</div>
        </Link>

        <Link to={`/dashboard/qusioner/${id}`}>
          <div className="bg-primary text-white px-4 py-2 rounded">Vote</div>
        </Link>
      </div>
    </div>
  );
};

export default EntryData;
